import authstore from '@/store/modules/auth';
import { clients } from '@/services/client.factory'

const categoryTree = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        TREE_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        TREE_UPDATE_ITEM(state, item) {
            state.item = Object.assign({}, state.item, item)
        },
        TREE_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        TREE_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        TREE_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);

            await clients.placeServiceClient.getCategoryTree(jwt.city_code)
                .then((res) => res.data)
                .then((data) =>
                    commit('TREE_SET_ITEMS', data)
                )
        },
        create(context) {
        },
        update(context) {
        },
        remove(context, item) {
        }
    }
}

export default categoryTree;